export default {
  'validation.required': 'Bu alan zorunludur.',
  'validation.type.number': 'Lütfen geçerli bir değer giriniz.',
  'validation.type.number.min': 'Lütfen {number} değerinden büyük bir değer giriniz.',
  'validation.type.number.max': 'Lütfen {number} değerinden küçük veya ona eşit bir değer giriniz.',
  'validation.type.string.min': 'Lütfen en az {number} karakter giriniz.',
  'validation.type.string.max': 'Lütfen en fazla {number} karakter giriniz.',
  'validation.type.date.greaterthan.today': 'Tarih günümüzden ileride olamaz.',
  'validation.type.number.range': 'Lütfen 0 ile {number} arasında rakam giriniz.',
  'validation.type.string.length.range':
    'Lütfen en az {min} en fazla {max} karakter arasında giriş yapınız.',
  'validation.bcp47': 'Lütfen BCP 47 formatını kullanınız.',
  'validation.type.string.guid': 'Geçersiz format. Lütfen GUID formatı kullanınız.',
  'validation.type.date': 'Geçersiz tarih formatı.',
  'validation.type.array.values.string': 'Lütfen en az {min} en fazla {max} karakter giriniz.',
  'validation.type.phoneNumber': 'Lütfen geçerli bir telefon numarası giriniz.',
  'validation.type.email': 'Lütfen geçerli bir e-posta adresi giriniz.',
  'validation.type.email.maxLength': 'Lütfen en fazla 100 karakter giriniz.',
  'validation.gender.type.enum': 'Cinsiyet Erkek veya Kadın olmalıdır.',
  'validation.type.date.future': 'Tarih gelecekte olmalıdır.',
  'validation.type.date.past': 'Tarih geçmişte olmalıdır.',
  'validation.idNo.invalid':
    'Lütfen geçerli bir T.C. kimlik numarası giriniz.',
  'validation.passportNo.invalid':
    'Lütfen geçerli bir pasaport numarası formatı giriniz (6-20 karakter, harf ve rakam).',
};
